import { AzureStorageLinkedService, IModel, IViolation, IAttribute, ModelConstants } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { HDInsightLinkedService } from '../linkedservice/hdinsight.linkedservice';
import { Activity } from './activity';
import { FilePath } from 'app/model/dataset/file-path';

import { createParameterConfigurationValidator } from 'app/model/adapters/linkedservices/parameter-config.util';
import { ParameterConfig } from 'app/model/pipeline/parameter-config';
import { HDInsightOnDemandLinkedService } from 'app/model/linkedservice/hdinsightondemand.linkedservice';
import { format } from 'app/shared/utils/string.util';
import { validateFilePath } from 'app/shared/utils/activity-validation.util';

@Metamodel.model({
    name: ModelConstants.mapReduceActivity,
    display: [
        format(stringResources.ModelName_ActivityTemplate, stringResources.MapReduceDisplayText),
        format(stringResources.ModelName_ActivitiesTemplate, stringResources.MapReduceDisplayText)
    ],
    referable: true
})
export class MapReduceActivity extends Activity {
    public static readonly MODEL: IModel;
    public static readonly CLASS_NAME: IAttribute;
    public static readonly JAR_FILE_PATH: IAttribute;
    public static readonly ARGUMENTS: IAttribute;

    @Metamodel.attribute({
        display: stringResources.FilePath_Label,
        constraint: {
            validator: MapReduceActivity.validateJarPath,
            required: true
        },
        templatable: true,
        accepts: ['String'],
        association: 'JAR_FILE_PATH'
    })
    public jarFilePath = new FilePath();

    @Metamodel.attribute({
        display: stringResources.JarLibsLabel
    })
    public jarLibs: string[] = [];
    @Metamodel.attribute({
        display: stringResources.ModelName_Arguments,
        association: 'ARGUMENTS',
        templatable: true,
        accepts: ['Array']
    })
    public mapReduceActivityArguments?: ParameterConfig[];
    public getDebugInfo?: string;
    @Metamodel.attribute({
        display: stringResources.ModelName_ClassName,
        constraint: {
            required: true
        },
        templatable: true,
        association: 'CLASS_NAME'
    })
    public className?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Defines,
        constraint: {
            validator: createParameterConfigurationValidator()
        }
    })
    public defines?: ParameterConfig[];

    @Metamodel.attribute({
        display: stringResources.JarLinkedServiceLabel,
        reference: true,
        type: AzureStorageLinkedService.MODEL
    })
    public jarLinkedService?: AzureStorageLinkedService; // Azure Storage linked service which contains the jar.

    @Metamodel.attribute({
        display: format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Hdi_DisplayName),
        constraint: {
            required: true
        },
        reference: true,
        type: HDInsightLinkedService.MODEL
    })
    public linkedService?: HDInsightLinkedService | HDInsightOnDemandLinkedService; // HDInsight linked service which hosts the mapreduce cluster.

    constructor(name?: string, description?: string) {
        super(name, description);
        this.activityType = 'ExecutionActivity';
    }

    private static validateJarPath(_activity?: MapReduceActivity, arg?: FilePath | undefined): IViolation[] | undefined {
        return validateFilePath(_activity, arg, MapReduceActivity.JAR_FILE_PATH);
    }
}
